import { FC } from 'react'

import { EVENT } from 'routes/paths'
import Banner from 'components/navigation/banner'
import { StarAuctionsQuery } from 'gql'
import { formatAuctionEndDate, getImageUrl } from '~utils'

type FeaturedAuctionsProps = {
  auctions: StarAuctionsQuery
}

const AuctionsBanner: FC<FeaturedAuctionsProps> = ({ auctions }) => {
  const edges = auctions?.allArtworks?.edges

  const items =
    edges?.map(
      ({
        node: {
          title,
          artworkOrTourOrArtistImage,
          description,
          currentBid,
          startingBid,
          slug: s,
          endDate,
          venue,
        },
      }) => ({
        imageUrl: getImageUrl(
          artworkOrTourOrArtistImage,
          edges.length > 2 ? 256 : 640,
          edges.length > 2 ? 256 : 280
        ),
        title,
        description,
        fields: [
          [{ text: formatAuctionEndDate(endDate, venue?.timeZone) }],
          [{ text: `Current Bid: $${currentBid || startingBid || 'XXXX'}` }],
        ],
        link: EVENT(s),
      })
    ) || []

  return items?.length ? <Banner items={items || []} title={items.length && 'Lots'} /> : null
}

export default AuctionsBanner
